import { useAppAlert } from '@/app/AppAlertProvider'
import { Button } from '@/app/common/components/Button'
import { UpdateApplicant } from '@/storage/applications/familyApplicationSlice'
import { selectProgramID } from '@/storage/program_settings/programSettingsSlice'
import { AppDispatch } from '@/storage/store'
import { zodResolver } from '@hookform/resolvers/zod'
import { useForm } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import FamilyWizardLayout from '../../FamilyWizardLayout'
import { SubmitButton } from '../../student_details/shared/submit-button'
import { SSNFormSchema, ssnFormSchema } from '../dws/Page'

interface Props {
  onSkipClick: () => void
  onAddSSNSuccess: () => void
}

function TaxCommissionSSNPage(props: Props) {
  const { onSkipClick, onAddSSNSuccess } = props
  const programID = useSelector(selectProgramID)
  const { t } = useTranslation()
  const dispatch = useDispatch<AppDispatch>()
  const { fireAlert } = useAppAlert()
  const { handleSubmit } = useForm<SSNFormSchema>({
    resolver: zodResolver(ssnFormSchema),
    defaultValues: {
      applicantSSN: '',
      spouseSSN: '',
      filingType: null,
    },
  })

  async function onSubmit(data: SSNFormSchema) {
    const updateApplicantResponse = await dispatch(
      UpdateApplicant({
        program_id: programID,
        SSN: data.applicantSSN,
      })
    )

    if (!UpdateApplicant.fulfilled.match(updateApplicantResponse)) {
      fireAlert({
        variant: 'error',
        title: true,
        titleText: 'Error updating applicant',
        message: 'Error updating applicant',
      })
    } else {
      onAddSSNSuccess()
    }
  }

  return (
    <FamilyWizardLayout>
      <FamilyWizardLayout.Header>
        {t('taxConsent.header')}
      </FamilyWizardLayout.Header>
      <FamilyWizardLayout.Content>
        <form onSubmit={handleSubmit(onSubmit)} className="space-y-6">
          {/*  <SSNInput
            getValues={getValues}
            register={register}
            setValue={setValue}
            encryptionMessage="taxConsent.encryptionMessage"
            error={errors.SSN?.message}
          /> */}
        </form>
      </FamilyWizardLayout.Content>
      <FamilyWizardLayout.ActionBar className="flex flex-col gap-2">
        <SubmitButton
          status="idle"
          buttonTxt={t('taxConsent.continue')}
          onClick={handleSubmit(onSubmit)}
        />
        <Button variant={'outline'} onClick={onSkipClick}>
          Skip
        </Button>
      </FamilyWizardLayout.ActionBar>
    </FamilyWizardLayout>
  )
}

export default TaxCommissionSSNPage
